import React from "react";

const PrivacyPolicy = () => {
  return (
    <div className="container check-mobile pt-2 align-items-start">
      <div className="check-box" style={{height:'auto'}}>
        <h4 className="mb-3" style={{fontSize:"15px"}}>صنعتبان چگونه از اطلاعات شما حراست می‌کند؟</h4>
        <p className="" style={{fontSize:"12px",wordSpacing:"1px",lineHeight:"26px"}}>
          با توجه به اهمیت حفظ و امنیت اطلاعات شما در وبسایت صنعتبان همواره تیم فنی صنعتبان آماده رویارویی با هر گونه حملات احتمالی می باشد و به طور ویژه از اطلاعات شما با روش های نوین حفاظت به عمل می آورد.
          چه اطلاعاتی از شما دریافت می‌شود؟
          در ابتدای ثبت نام از شما شماره تلفن همراه دریافت می شود. این شماره تلفن جهت پیگیری های درخواست ثبت آگهی شما می باشد. همچنین برخی اطلاعات مانند ایمیل و جنسیت صرفا جهت ارسال پیام های تخفیف و اطلاع از اخبار مهم وبسایت می باشد.
          چگونه از اطلاعات شما محافظت می‌شود؟
          وبسایت صنعتبان از بستر امن HTTPS استفاده می کند و همواره با در نظر گرفتن اهمیت اطلاعات کاربران آماده مقابله با هر گونه حمله احتمالی می باشد.
          چه استفاده‌ای اطلاعات شما خواهد شد؟
          چه از نظر قانونی چه از نظر اخلاقی ما موظف به صیانت از اطلاعات و پرونده‌های شما هستیم. اطلاعات شخصی شما نیز صرفاً جهت تعاملات بعدی به صورت کدگذاری‌شده نگهداری می‌شوند تا در سفارش‌ها و درخواست‌های آینده بتوانید به راحتی وارد سامانه شوید و سفارش خود را ثبت نمایید. ما هم از اسپم متنفریم و ایمیل‌ها و پیام‌های تبلیغاتی را برای کاربران‌مان ارسال نخواهیم کرد.
          چه کسانی به اطلاعات شما دسترسی دارند؟
          همکاران بخش پشتیبانی و خدمات پس از فروش به برخی از اطلاعات شما دسترسی دارند آن هم برای ارائه پشتیبانی بهتر و خدمات با کیفیت‌تر مورد استفاده قرار می‌گیرد. تمامی اطلاعات شخصی شما نزد ما محفوظ خواهد ماند و در اختیار افراد یا سازمان‌های دیگری قرار نخواهد گرفت. بدیهی است که مراجع قانونی با ارائه حکم دادگاه قادرند به این اطلاعات دسترسی داشته باشند. به طور کلی ما موظفیم از اطلاعات شما حفاظت و حراست نماییم.
        </p>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
